import { render, staticRenderFns } from "./ContactArea.vue?vue&type=template&id=03997635&"
import script from "./ContactArea.vue?vue&type=script&lang=js&"
export * from "./ContactArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports